import { render, staticRenderFns } from "./PackageItemsList.vue?vue&type=template&id=1175d97c&scoped=true&"
import script from "./PackageItemsList.vue?vue&type=script&lang=js&"
export * from "./PackageItemsList.vue?vue&type=script&lang=js&"
import style0 from "./PackageItemsList.vue?vue&type=style&index=0&id=1175d97c&lang=scss&scoped=true&"
import style1 from "./PackageItemsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1175d97c",
  null
  
)

export default component.exports